import { common as en_common } from "../en/common";

/** common — ES slice (55 keys). */
export const common: Record<keyof typeof en_common, string> = {
  time_seconds_short: "{time}s",
  time_minutes_short: "{time}min",
  time_hours_short: "{time}h",
  time_days_short: "{time}d",
  time_weeks_short: "{time}sem",
  time_months_short: "{time}mes",
  time_years_short: "{time}a",
  time_ago_text: "hace {time}",
  common_app_name: "Linqx",
  common_copy: "Copiar",
  common_close: "Cerrar",
  common_skip: "Omitir",
  common_submit: "Enviar",
  common_continue: "Continuar",
  common_message_copied: "Copiado.",
  common_error_access_denied: "Acceso denegado",
  common_error_title: "Error",
  common_save: "Guardar",
  common_create: "Crear",
  common_delete: "Eliminar",
  common_not_found_placeholder_title: "Página no encontrada",
  common_not_found_placeholder_description:
    "Lo sentimos, no pudimos encontrar la página que buscas.",
  common_not_found_placeholder_button: "Inicio",
  common_network_error_title: "Revisa tu conexión",
  common_network_error_description:
    "Hay un problema temporal con tu conexión de red. Asegúrate de estar conectado a internet y vuelve a cargar la app.",
  common_network_error_reload_button: "Recargar",
  common_select_photo: "Subir foto",
  common_take_photo: "Tomar foto",
  common_choose_from_library: "Elegir de la galería",
  common_unable_to_save_file: "No se pudo guardar el archivo",
  common_camera_permission_denied:
    "Se necesita acceso a la cámara para tomar una foto. Actívalo en Ajustes.",
  common_message_changes_saved: "Los cambios se guardaron correctamente.",
  signin_btn: "Iniciar sesión",
  submit_btn: "Enviar",
  save: "Guardar",
  about_activation_finish:
    "Al pulsar Iniciar sesión, aceptas los {terms} y la {privacy}",
  about_activation_finish_privacy: "Política de privacidad",
  about_activation_finish_terms: "Términos del servicio",
  connecting: "Conectando..",
  signout: "Cerrar sesión",
  no_results: "No se encontraron resultados",
  intro_title: "Linqx",
  intro_description:
    "Disfruta la nueva forma de conectar con tus nuevos amigos",
  error_alert_ok: "Ok",
  error_alert_title: "Error",
  error_try_again: "Reintentar",
  internet_connection_error:
    "Lo sentimos, no hay conexión. Revisa la configuración de tu conexión a internet.",
  about_app_privacy: "Política de privacidad",
  about_app_terms_privacy: "Términos y privacidad",
  about_app_terms: "Términos del servicio",
  tab_item_messages: "Chats recientes",
  tab_item_geo_search: "Búsqueda geográfica",
  tab_item_profile: "Perfil",
  tab_item_events: "Eventos",
  common_cancel: "Cancelar",
  common_loading: "Cargando...",
  common_block_confirm_title: "¿Bloquear a esta persona?",
  common_block_confirm_message:
    "Dejaréis de veros. Esto no se puede deshacer desde aquí.",
  common_block_confirm_confirm: "Bloquear",
  common_block_error: "No se pudo bloquear. Inténtalo de nuevo.",
  common_block: "Bloquear",
  common_report: "Reportar",
  common_linq: "LINQ",
  common_nope: "NOPE",
  report_reason_label: "Motivo",
  report_reason_spam: "Spam",
  report_reason_scam: "Estafa o fraude",
  report_reason_abuse: "Abuso o contenido inapropiado",
  report_reason_harassment: "Acoso o intimidación",
  report_reason_other: "Otro",
  report_message_label: "Mensaje (opcional)",
  report_message_placeholder:
    "Añade cualquier detalle que nos ayude a revisar este reporte.",
  report_submit: "Enviar",
  report_submitting: "Enviando…",
  report_pick_reason: "Elige un motivo.",
  report_no_bridge: "El puente de reportes no está disponible.",
  report_standalone:
    "Ejecutándose sin el host de Linqx — el envío está deshabilitado.",
  report_target_label: "Reportando:",
};
